export default {"src":"/_next/static/media/video.7dd36aba.svg","height":14,"width":21};